module.exports = __webpack_public_path__ + "static/media/dissectDetail1.0629673a.jpeg";